export enum DateFormat {
  C = 'C',
  D = 'D',
  DT = 'DT',
  Y = 'Y',
  YM = 'YM',
}

export const DEFAULT_RANGE: [number, number] = [1, new Date().getFullYear()];
